import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  UserCircle,
  Briefcase,
  LogOut,
  Star,
  User,
  CreditCard,
  Users
} from 'lucide-react';

import { useAuth } from '../../../context/AuthContext';
import './CastingDirectorSidebar.css';

const CastingDirectorSidebar = () => {

  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [showDrawer, setShowDrawer] = useState(false);
  const handleClose = () => setShowDrawer(false);

  const handleLogout = () => {
    logout();
    handleClose();
    navigate('/login');
  };

  // USER DATA (Copied logic from TalentSidebar)
  const displayName = user?.full_name || 'Casting Director';
  const displayRole = user?.role || 'Casting Director';
  const profileImageUrl = user?.profile_image_url || '';

  // FALLBACK AVATAR
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=d90429&color=fff&size=150`;

  const imageSource = profileImageUrl ? profileImageUrl : defaultAvatar;

  return (
    <div className="cd-sidebar py-4">

      {/* MAIN CARD */}
      <div className="cd-main-card mt-5">

        {/* PROFILE */}
        <div className="sidebar-profile text-center mb-4">

          <img
            src={imageSource}
            alt="Casting Director"
            className="td-profile-img"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <h4>{displayName}</h4>

          <p>{displayRole}</p>

        </div>


        {/* SIDEBAR MENU */}

        <div className="cd-sidebar-nav">

          <NavLink
            to="/dashboard/overview"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <User size={18} /> Dashboard
          </NavLink>
          <NavLink
            to="/dashboard/profile"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <UserCircle size={16} /> Profile
          </NavLink>




          <NavLink
            to="/dashboard/projects"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <Briefcase size={18} /> Projects
          </NavLink>


          <NavLink
            to="/dashboard/roles"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <Users size={18} /> Manage Roles
          </NavLink>


          <NavLink
            to="/dashboard/manage-applications"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <Users size={16} /> Audition
          </NavLink>


          <NavLink
            to="/dashboard/transaction-history"
            className={({ isActive }) =>
              isActive ? "cd-menu-item active" : "cd-menu-item"
            }
          >
            <CreditCard size={16} /> Billing
          </NavLink>

        </div>


        {/* LOGOUT */}

        <div
          className="logout mt-3 pt-3 border-top border-secondary d-flex align-items-center gap-2 text-danger"
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          <LogOut size={16} />
          <span className="fw-bold">Sign Out</span>
        </div>

      </div>


      {/* PRO FEATURES CARD */}

      <div className="cd-pro-card">

        <div className="pro-title">
          <Star size={16} />
          <span>Pro Features</span>
        </div>

        <p className="pro-text">
          Unlock AI self-tape scoring and priority role matching.
        </p>

        <button className="pro-btn">
          Upgrade Now
        </button>

      </div>

    </div>
  );
};

export default CastingDirectorSidebar;